//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

//
// Schemas
//

export const RequestBodySchema = z.object(
	{
		blogPostId: z.coerce.number().int().min(1),

		contents: z.string(),
		publishedState: z.number(),
		summary: z.string(),
		title: z.string(),
		url: z.string(),

		authorUserIds: z.array(z.coerce.number().int().min(1)),
		forumTopicId: z.coerce.number().int().min(0).nullish(),
		topics: z.array(z.string()),
	});

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema,
		
		FritterApiUtilities.ErrorResponseBodySchema,
	]);

//
// Types
//

export type RequestBody = z.infer<typeof RequestBodySchema>;

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

//
// Constants
//

export const method = "POST";

export const path = "/v7/blogPosts/update";

//
// Utility Functions
//

export function updateBlogPost(apiUrl: string, requestBody: RequestBody)
{
	return FritterApiUtilities.request(method, apiUrl + path,
		{
			requestBodySchema: RequestBodySchema,
			responseBodySchema: ResponseBodySchema,
			requestBody,
		});
}